/*
 * Artisan Roast - Gift coffee subscription form (Recharge gifting widget).
 * 1. Rebuilds the layout and wording, and merges first name + last name into one visible field.
 *    The two original Recharge inputs stay in the page (hidden) and are filled from the single field,
 *    so Recharge still receives __rc_gift_recipient_first_name and __rc_gift_recipient_last_name.
 * 2. Shows one "Subscription length" selector (3 / 6 / 12 months). Each length is its own gift product
 *    (Recharge links one gift product to one redeemable plan), so the buttons are links between the products.
 *    The list of lengths comes from the JSON block printed by snippets/ar-gift-config.liquid.
 * 3. The main button reads SEND SUBSCRIPTION with no price (the label is drawn by assets/ar-gift-form.css).
 * 4. The opening sentence of the product description ("Elevate your loved ones' coffee experience...") moves up
 *    under the price, without the length ("our gift subscriptions"). The rest of the description stays below.
 * 5. A short note explains who enters which address (see T.hint). The recipient only chooses the grind;
 *    the roastery team picks the coffee.
 *
 * Recharge validates the whole gift form when it loads and shows the browser's "Please fill in this field"
 * bubble on the first empty required input in page order. The hidden first/last name inputs stay required while
 * the name is empty; once someone types a name, the visible field takes over (and shows its own message for a
 * one-word name).
 */
(function () {
  if (window.arGiftFormInit) { return; }
  window.arGiftFormInit = true;

  var T = {
    title: 'Who is it for?',
    name: 'Their name and surname',
    namePh: 'e.g. Anna Smith',
    nameErr: 'Please add their first name and surname.',
    email: 'Their email',
    emailPh: 'name@example.com',
    msg: 'Your message to them (optional)',
    msgPh: 'A few words for them to read when we send the gift',
    from: 'From (optional)',
    fromPh: 'Your name',
    date: 'Tell them on',
    hint: 'We email them on the day you choose. They decide how they like it ground and add their own delivery address, so at checkout you only enter your own details.',
    length: 'Subscription length',
    send: 'Send subscription'
  };

  var css = document.createElement('style');
  css.textContent = '.ar-gift-intro{margin:0 0 22px;font-size:14px;line-height:1.5}.ar-gift-intro-src{display:none!important}';
  document.head.appendChild(css);

  function el(tag, cls) {
    var n = document.createElement(tag);
    if (cls) { n.className = cls; }
    return n;
  }
  function fire(node) {
    node.dispatchEvent(new Event('change', { bubbles: true }));
  }
  function setLabel(input, text) {
    var l = input.parentNode.querySelector('label');
    if (l) { l.textContent = text; }
  }

  function sendButton() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      var b = forms[i].querySelector('[data-add-to-cart]');
      if (b && forms[i].querySelector('[name="id"]') && /subscribe|add to cart|send/i.test(b.textContent)) { return b; }
    }
    return null;
  }

  function intro(anchor) {
    if (!anchor || document.querySelector('.ar-gift-intro')) { return; }
    var ss = document.querySelectorAll('.text__content strong');
    for (var i = 0; i < ss.length; i++) {
      var txt = ss[i].textContent.trim();
      if (/^(Gift someone Artisan Roast|Elevate your loved ones)/i.test(txt)) {
        var p = el('p', 'ar-gift-intro');
        p.textContent = txt.replace(/\bour\s+\d+-month\s+gift/i, 'our gift');
        anchor.parentNode.insertBefore(p, anchor);
        ss[i].classList.add('ar-gift-intro-src');
        var par = ss[i].parentElement;
        if (par && par.textContent.trim() === txt) { par.classList.add('ar-gift-intro-src'); }
        return;
      }
    }
  }

  function lengths(c) {
    if (document.querySelector('.ar-len')) { return; }
    var data = [];
    try { data = JSON.parse(document.getElementById('ar-gift-lengths').textContent); } catch (e) { return; }
    data = (data || []).filter(function (d) { return d && d.label && d.url; });
    if (data.length < 2) { return; }

    var box = el('div', 'ar-len');
    var lab = el('p', 'ar-gf__title');
    lab.textContent = T.length;
    var row = el('div', 'ar-len__row');
    data.forEach(function (d) {
      var a = el('a', 'ar-len__btn');
      a.href = d.url;
      a.textContent = d.label.replace(/\s*£.*$/, '');
      if (d.current) { a.setAttribute('aria-current', 'true'); }
      row.appendChild(a);
    });
    box.appendChild(lab);
    box.appendChild(row);
    c.parentNode.insertBefore(box, c);

    /* The single-option picker ("Subscription / 6 MONTHS £75") is replaced by the selector above */
    var legends = document.querySelectorAll('.radio__legend__label');
    for (var i = 0; i < legends.length; i++) {
      if (/^subscription$/i.test(legends[i].textContent.trim())) {
        var fs = legends[i].closest('fieldset') || legends[i].parentNode.parentNode;
        fs.classList.add('ar-len-hide');
      }
    }

    /* Page heading without the length, since the length is now chosen above */
    var h = document.querySelector('main h1');
    if (h && /\s\d+\s*months?\s*$/i.test(h.textContent)) {
      h.textContent = h.textContent.replace(/\s*\d+\s*months?\s*$/i, '');
    }
  }

  function build(c) {
    var first = c.querySelector('#rc_gift_recipient_first_name');
    var last = c.querySelector('#rc_gift_recipient_last_name');
    var email = c.querySelector('#rc_gift_recipient_email');
    var msg = c.querySelector('#rc_gift_message');
    var from = c.querySelector('#rc_gift_sender_name');
    var date = c.querySelector('#rc_gift_notification_scheduled_at');
    if (!first || !last || !email || !msg || !from || !date) { return; }

    var msgWrap = msg.closest('.field').parentNode;
    var wrap = el('div', 'ar-gf');

    var title = el('p', 'ar-gf__title');
    title.textContent = T.title;
    wrap.appendChild(title);

    /* One visible name field */
    var nameField = el('div', 'field');
    var nameInput = el('input', 'ar-gf__input');
    nameInput.type = 'text';
    nameInput.id = 'ar_gift_recipient_name';
    nameInput.required = true;
    nameInput.maxLength = 101;
    nameInput.autocomplete = 'off';
    nameInput.placeholder = T.namePh;
    var nameLabel = el('label', 'field__label');
    nameLabel.setAttribute('for', nameInput.id);
    nameLabel.textContent = T.name;
    nameField.appendChild(nameInput);
    nameField.appendChild(nameLabel);
    wrap.appendChild(nameField);

    /* Fill the hidden Recharge inputs while typing; tell Recharge once the person leaves the field */
    function split() {
      var parts = nameInput.value.split(' ').filter(Boolean);
      first.value = parts.length ? parts[0] : '';
      last.value = parts.length > 1 ? parts.slice(1).join(' ') : '';
      nameInput.setCustomValidity(parts.length === 1 ? T.nameErr : '');
      first.required = parts.length === 0;
      last.required = parts.length === 0;
    }
    nameInput.addEventListener('input', split);
    nameInput.addEventListener('blur', function () { split(); fire(first); fire(last); });
    if (first.value || last.value) { nameInput.value = (first.value + ' ' + last.value).trim(); split(); }

    /* Email */
    setLabel(email, T.email);
    email.placeholder = T.emailPh;
    email.autocomplete = 'off';
    wrap.appendChild(email.closest('.field'));

    /* Message (field + character count) */
    setLabel(msg, T.msg);
    msg.placeholder = T.msgPh;
    wrap.appendChild(msgWrap);

    /* From + date on one row */
    setLabel(from, T.from);
    from.placeholder = T.fromPh;
    from.autocomplete = 'name';
    setLabel(date, T.date);
    var row = el('div', 'ar-gf__row');
    row.appendChild(from.closest('.field'));
    row.appendChild(date.closest('.field'));
    wrap.appendChild(row);

    var hint = el('p', 'ar-gf__hint');
    hint.textContent = T.hint;
    wrap.appendChild(hint);

    /* After the hidden original block, so the hidden required inputs stay first in page order */
    c.appendChild(wrap);
    c.setAttribute('data-ar-ready', '');
    lengths(c);
    intro(document.querySelector('.ar-len') || c);
  }

  function button() {
    var b = sendButton();
    if (b && !b.classList.contains('ar-send-btn')) {
      b.classList.add('ar-send-btn');
      b.setAttribute('aria-label', T.send);
    }
  }

  function pass() {
    var list = document.querySelectorAll('.rc_gifting_container:not([data-ar-ready])');
    for (var i = 0; i < list.length; i++) { build(list[i]); }
    var ready = document.querySelector('.rc_gifting_container[data-ar-ready]');
    if (ready) { intro(document.querySelector('.ar-len') || ready); }
    button();
  }

  pass();
  setInterval(pass, 400);
})();